import { render, staticRenderFns } from "./housekeepingSjServList.vue?vue&type=template&id=91a6a498&scoped=true"
import script from "./housekeepingSjServList.vue?vue&type=script&lang=js"
export * from "./housekeepingSjServList.vue?vue&type=script&lang=js"
import style0 from "./housekeepingSjServList.vue?vue&type=style&index=0&id=91a6a498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a6a498",
  null
  
)

export default component.exports